import { ConversationLinkActions } from '@marketplace-web/domain/conversation-messaging-data'

import {
  TrackShipmentLink,
  DropOffPointMapLink,
  PickUpParcelLink,
} from '@marketplace-web/domain/conversation-shipping'
import { BuyerDetailsLink } from '@marketplace-web/domain/conversation-user'
import {
  OfflineVerificationInfoLink,
  ElectronicsVerificationInfoLink,
} from '@marketplace-web/domain/escrow-pricing'

type Props = {
  action: string
}

const LinkAction = ({ action }: Props) => {
  switch (action) {
    case ConversationLinkActions.ShipmentTrackingLink:
      return <TrackShipmentLink />
    case ConversationLinkActions.BuyerDetailsLink:
      return <BuyerDetailsLink />
    case ConversationLinkActions.OfflineVerificationInfoLink:
      return <OfflineVerificationInfoLink />
    case ConversationLinkActions.DropOffPointMapLink:
      return <DropOffPointMapLink />
    case ConversationLinkActions.ReactElectronicsVerificationInfoLink:
      return <ElectronicsVerificationInfoLink />
    case ConversationLinkActions.PickUpParcelLink:
      return <PickUpParcelLink />
    default:
      return null
  }
}

export default LinkAction
